import moment from 'moment';
import { message } from 'ant-design-vue';

export default {
  namespaced: true,
  state: {
    /*表单提交全部数据*/
    containerData: {},
    /*监装下单返回数据*/
    dataOrder: false,
    /*监装订单保存草稿箱返回数据*/
    draftsState: false,
    /*当前用户信息*/
    user: {},
    /*城市联动*/
    //区分省市区数据
    areaOne: '',
    areaTow: '',
    areaThree: '',
    // 语言切换
    orderReporttype: '1',
  },
  actions: {
    /**
     * 监装订单下单
     */
    async supervisionDown({ commit }, data) {
      console.log('data', data);
      const formDataMap = data.formDataMap;
      // const orderType = data.orderType;
      const tableDataList = data.tableData;
      const fileList = data.fileId;
      console.log('====fileList=====', fileList);
      const orState = data.orState;
      if (sessionStorage.getItem('user') !== null) {
        this.user = JSON.parse(sessionStorage.getItem('user'));
      }
      const userId = this.user !== {} ? this.user.id : '';
      let date = '';
      // 区域
      let areaList = '';
      if (
        formDataMap !== null &&
        formDataMap !== '' &&
        formDataMap !== undefined &&
        formDataMap !== {} &&
        JSON.stringify(formDataMap) !== '{}'
      ) {
        let lang = '';
        // 获取国际化sessionStorage信息
        if (sessionStorage.getItem('lang') !== null) {
          lang = JSON.parse(sessionStorage.getItem('lang')) || '';
        }
        if (formDataMap.orderFactoryarea !== undefined && lang !== 'en-US') {
          console.log('formDataMap', formDataMap);
          const areaOne = formDataMap.orderFactoryarea[0];
          const areaTow = formDataMap.orderFactoryarea[1];
          const areaThree = formDataMap.orderFactoryarea[2];
          // 时间格式YYYYMMDDHHmmss
          //  日期转换
          date = moment(formDataMap.orderServicedate).format('YYYY-MM-DD');
          // 拼接省市区
          if (areaThree !== undefined) {
            areaList = areaOne + '/' + areaTow + '/' + areaThree;
          } else {
            areaList = areaOne + '/' + areaTow;
          }
        }
        if (lang === 'en-US') {
          areaList = '北京市/市辖区';
        }
        const orderReporttype = data.orderReporttype;

        const resData = await this.$http.post('/hzwmj/workorder/addWorkOrder', {
          orderFactoryname: formDataMap.orderFactoryname,
          orderFactoryarea: areaList,
          orderFactoryaddress: formDataMap.orderFactoryaddress,
          orderFactoryperson: formDataMap.orderFactoryperson,
          orderFactoryfixedtel: formDataMap.orderFactoryfixedtel,
          orderFactorytel: formDataMap.orderFactorytel,
          orderFactoryemail: formDataMap.orderFactoryemail,
          orderTrustcompany: formDataMap.orderTrustcompany,
          orderTrustaddress: formDataMap.orderTrustaddress,
          orderTrustperson: formDataMap.orderTrustperson,
          orderTrustfixedtel: formDataMap.orderTrustfixedtel,
          orderTrusttel: formDataMap.orderTrusttel,
          orderTrustemail: formDataMap.orderTrustemail,
          orderdate: date,
          orderRequire: formDataMap.orderRequire,
          //订单类型（服务类型）
          orderType: '5',
          orderReporttype: orderReporttype,
          // 产品数据
          productlist: tableDataList,
          fileList: fileList,
          // 检验标准
          // orderStandard: 'ANSI/ASQ Z1.4 Single Sampling Plan',
          // //检验水平
          // orderLevel: formDataMap.aql,
          // //致命缺陷
          // orderFataldefect: formDataMap.criterion,
          // //严重缺陷
          // orderSeriousdefect: formDataMap.serious,
          // //轻微缺陷
          // orderMinordefect: formDataMap.slight,
          // 订单状态：0下单，草稿箱10
          orderState: orState === 10 ? '10' : '0',
          //检验资料/款式附件
          orderAnnex: fileList,
          trustpersonId: userId,
          // 订单号
          orderIdNum: data.orderIdFrom,
        });
        if (resData.code === 200) {
          if (orState === 10) {
            if (resData.data === true) {
              console.log('订单保存草稿箱成功');
              // this.dataOrder = false;
              message.success('订单保存草稿箱成功');
              const draftsState = resData.data;
              console.log('draftsState', draftsState);
              commit('save', { draftsState });
            } else {
              message.error('订单保存草稿箱失败');
              const draftsState = resData.data;
              console.log('draftsState', draftsState);
              commit('save', { draftsState });
            }
          } else {
            if (resData.data === true) {
              message.success('生成订单成功');
            } else {
              message.error('生成订单失败');
            }
          }
          const dataOrder = resData.data;
          console.log('dataOrder', dataOrder);
          commit('save', { dataOrder });
        } else if (resData.code === 900) {
          message.error(resData.msg);
        } else {
          message.error('系统异常');
        }
      }
    },
    /**
     * 监装订单修改下单
     */
    async updateWorkOrder({ commit }, data) {
      console.log('data============', data);
      const formDataMap = data.formDataMap;
      // const orderType = data.orderType;
      const tableDataList = data.tableData;
      const fileList = data.fileId;
      console.log('====fileList=====', fileList);
      const orState = data.orState;
      if (sessionStorage.getItem('user') !== null) {
        this.user = JSON.parse(sessionStorage.getItem('user'));
      }
      const userId = this.user !== {} ? this.user.id : '';
      let date = '';
      // 区域
      let areaList = '';
      if (
        formDataMap !== null &&
        formDataMap !== '' &&
        formDataMap !== undefined &&
        formDataMap !== {} &&
        JSON.stringify(formDataMap) !== '{}' &&
        formDataMap.orderFactoryarea !== undefined
      ) {
        console.log('formDataMap', formDataMap);
        const areaOne = formDataMap.orderFactoryarea[0];
        const areaTow = formDataMap.orderFactoryarea[1];
        const areaThree = formDataMap.orderFactoryarea[2];
        // 时间格式YYYYMMDDHHmmss
        //  日期转换
        date = moment(formDataMap.orderServicedate).format('YYYY-MM-DD');
        // 拼接省市区
        if (areaThree !== undefined) {
          areaList = areaOne + '/' + areaTow + '/' + areaThree;
        } else {
          areaList = areaOne + '/' + areaTow;
        }
        const orderReporttype = data.orderReporttype;

        const resData = await this.$http.post(
          '/hzwmj/workorder/updateWorkOrder',
          {
            orderFactoryname: formDataMap.orderFactoryname,
            orderFactoryarea: areaList,
            orderFactoryaddress: formDataMap.orderFactoryaddress,
            orderFactoryperson: formDataMap.orderFactoryperson,
            orderFactoryfixedtel: formDataMap.orderFactoryfixedtel,
            orderFactorytel: formDataMap.orderFactorytel,
            orderFactoryemail: formDataMap.orderFactoryemail,
            orderTrustcompany: formDataMap.orderTrustcompany,
            orderTrustaddress: formDataMap.orderTrustaddress,
            orderTrustperson: formDataMap.orderTrustperson,
            orderTrustfixedtel: formDataMap.orderTrustfixedtel,
            orderTrusttel: formDataMap.orderTrusttel,
            orderTrustemail: formDataMap.orderTrustemail,
            orderdate: date,
            orderRequire: formDataMap.orderRequire,
            //订单类型（服务类型）
            orderType: '5',
            orderReporttype: orderReporttype,
            // 产品数据
            productlist: tableDataList,
            fileList: fileList,
            // 检验标准
            // orderStandard: 'ANSI/ASQ Z1.4 Single Sampling Plan',
            // //检验水平
            // orderLevel: formDataMap.aql,
            // //致命缺陷
            // orderFataldefect: formDataMap.criterion,
            // //严重缺陷
            // orderSeriousdefect: formDataMap.serious,
            // //轻微缺陷
            // orderMinordefect: formDataMap.slight,
            // 订单状态：0下单，草稿箱10
            orderState: orState === 10 ? '10' : '0',
            //检验资料/款式附件
            orderAnnex: fileList,
            trustpersonId: userId,
            // 订单号
            orderIdNum: data.orderIdFrom,
          },
        );
        if (resData.code === 200) {
          if (orState === 10) {
            if (resData.data === true) {
              message.success('订单保存草稿箱成功');
            } else {
              message.error('订单保存草稿箱失败');
            }
          } else {
            if (resData.data === true) {
              message.success('生成订单成功');
            } else {
              message.error('生成订单失败');
            }
          }
          const dataOrder = resData.data;
          console.log('dataOrder', dataOrder);
          commit('save', { dataOrder });
        } else if (resData.code === 900) {
          message.error(resData.msg);
        } else {
          message.error('系统异常');
        }
      }
    },
  },
  mutations: {
    /**
     * 保存状态
     * @param state
     * @param payload
     */
    save(state, payload) {
      for (let key of Object.keys(payload)) {
        state[key] = payload[key];
      }
    },
  },
};
